<template>
	<div class="overinvoices">
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.1rem" @click="back" />
			<span v-if="this.$route.query.applyinvoice != undefined">选择开票信息</span>
			<span v-else>发票信息</span>
			<div></div>
		</div>
		<div class="block">
			<van-radio-group v-model="radio" checked-color="#F1452F">
				<div v-if="invoicelist == ''" style="text-align: center;">暂无开票信息,点击添加一个吧~</div>
				<div v-else class="desBtn" v-for="(item,idnex) in invoicelist" :key="index">
					<div>
						<div>发票抬头：</div>
						<span>{{item.title}}</span>
					</div>
					<div>
						<div>纳税人识别号：</div>
						<span>{{item.number}}</span>
					</div>
					<div>
						<div>地址、电话：</div>
						<span>{{item.address}}&nbsp;{{item.tel}}</span>
					</div>
					<div>
						<div>开户行及账号：</div>
						<span>{{item.name}}&nbsp;{{item.card}}</span>
					</div>
					<van-radio class="select" :name="item.id" style="width: 10%;"></van-radio>
					<div class="star">
						<van-button round plain type="primary" color="#999" @click="go('invoice',item.id)">更改</van-button>
						<van-button round type="info" color="#F1452F" @click="deleteinvoice(item.id)">删除</van-button>
					</div>
				</div>
			</van-radio-group>
		</div>
		<div style="width: 100%; height: 5rem;"></div>
		<div class="addfpxx">
			<div class="fpstar">
				<div style="width: 30%;">选择发票类型:</div>
				<van-radio-group v-model="type2" direction="horizontal" style="width: 80%;" icon-size="16px" checked-color="#F1452F">
					<van-radio name="1">增值税普通发票</van-radio>
					<van-radio name="0">增值税专用发票</van-radio>
				</van-radio-group>
			</div>
			<div class="sedfse" v-if="this.$route.query.applyinvoice != undefined">
				<div class="bottom" @click="go('invoice')">添加发票信息</div>
				<div class="bottom" @click="applyinvoice" style="background: linear-gradient(to right,#ff6034,#ee0a24);">申请开票</div>
			</div>
			<div class="sedfse" v-else>
				<div class="bottom" @click="go('invoice')" style="width: 100%; margin:auto; background: linear-gradient(to right,#ff6034,#ee0a24);">添加发票信息</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				invoicelist: '',
				radio: '',
				type2: '1'
			}
		},
		created() {
			this.getinvoicelist();
		},
		methods: {
			// 获取数据
			getinvoicelist() {
				this.$axios.post(baseUrl + '/mobile/Bill/getList', {
					token: localStorage.getItem('Authorization')
				}).then((res) => {
					this.radio = res.data.data[0].id //设置第一个为默认选项
					this.invoicelist = res.data.data
				}).catch((err) => {
					console.log(err);
				});
			},
			// 删除事件
			deleteinvoice(ids) {
				this.$axios.post(baseUrl + '/mobile/Bill/del', {
					token: localStorage.getItem('Authorization'),
					id: ids
				}).then((res) => {
					if (res.data.code == 9) {
						this.$toast("删除成功");
						this.getinvoicelist();
					}
				}).catch((err) => {
					console.log(err);
				});
			},
			// 跳转事件
			go(id, e) {
				var that = this;
				that.$router.push({
					path: "/" + id,
					query: {
						id: e
					}
				})
			},
			applyinvoice() {
				if (this.$route.query.applyinvoice == undefined) {
					this.$toast("请从需开票商品的订单页点击进入");
				} else {
					this.$axios.post(baseUrl + '/mobile/Bill/apply', {
						token: localStorage.getItem('Authorization'),
						bill_id: this.radio,
						order_id: this.$route.query.applyinvoice,
						type2: this.type2
					}).then((res) => {
						if (res.data.code == 2) {
							this.$toast("申请成功请等待审核");
							this.$router.push({
								path: "/orderDetail",
								query: {
									order_number: this.$route.query.jump
								}
							})
						}
					}).catch((err) => {
						console.log(err);
					});
				}
			},
		},
	}
</script>

<style>
	.overinvoices .block {
		width: 94%;
		margin: auto;
		margin-top: 3.125rem;
		border-radius: 0.65rem;
		padding: 0.875rem 0;
		text-align: left;
	}

	.overinvoices .desBtn {
		margin-bottom: 0.625rem;
		background-color: #fff;
		padding: 0.625rem;
		border-radius: 0.625rem;
		font-size: 0.75rem;
		line-height: 1.25rem;
		position: relative;
	}

	.overinvoices .desBtn>div {
		display: flex;
		justify-content: left;
	}

	.overinvoices .desBtn>div>div {
		width: 5.625rem;
	}

	.overinvoices .desBtn>div>span {
		width: 73%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap
	}

	.overinvoices .desBtn .star {
		width: 90%;
		margin: auto;
		display: flex;
		justify-content: space-between;
		margin-top: 0.8125rem;
	}

	.overinvoices .van-button {
		width: 37%;
		height: 1.5rem;
		font-size: 0.75rem;
		line-height: 1.5rem;
	}

	.overinvoices .addfpxx {
		position: fixed;
		bottom: 0;
		left: 0;
		text-align: center;
		width: 100%;
		height: 5.5rem;
		line-height: 2.5rem;
		font-size: 0.875rem;
		background: #fff;
		color: #fff;

	}

	.overinvoices .sedfse {
		display: flex;
		justify-content: space-between;
		height: 3rem;
		width: 86%;
		padding: 0 7%;
	}

	.overinvoices .fpstar {
		display: flex;
		justify-content: space-between;
		font-size: 0.75rem;
		color: #000;
		border-bottom: 1px solid #eee;
	}

	.overinvoices .addfpxx .bottom {
		width: 40%;
		height: 2rem;
		border-radius: 999px;
		color: #fff;
		line-height: 2rem;
		margin-top: 0.5rem;
		background: linear-gradient(to right, #ffd01e, #ff8917);
	}

	.overinvoices .select {
		position: absolute;
		top: 0.625rem;
		right: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/overinvoices/overinvoices.vue